import React, { useState, useEffect, useRef } from "react";
import clsx from 'clsx';
import { AppBar, Toolbar, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import withCurrentUser from '../../../hocs/with_current_user.js';
import { compose } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

import Container from "../../../base/components/container.js";
import Tooltip from "../../../base/components/tooltip.js";
import Image from "../../../base/components/image.js";
import I18n from "../../../base/i18n.js";

import IcMenu from "../../../resources/icons/ic_menu.js";
import IcLightUser from "../../../resources/icons/ic_light_user.js";
import IcFilledUser from "../../../resources/icons/ic_filled_user.js";
import MybilioTextBronze from "../../../resources/logo/mybilio_text_bronze.js";
import MybilioTextLogoBronze from "../../../resources/logo/mybilio_text_logo_bronze.js";

import IcBlueBadge from "../../../resources/icons/badges/ic_blue_badge.js";
import IcRedBadge from "../../../resources/icons/badges/ic_red_badge.js";
import IcGrayBadge from "../../../resources/icons/badges/ic_gray_badge.js";
import IcGreenBadge from "../../../resources/icons/badges/ic_green_badge.js";

import { UserModel } from "../../../models/users/user_model.js"

import Routes from "../../routes.js";

import LeftMenu from "./left_menu.js";

export const TopBarHeight = "4rem";

const blockStyles = makeStyles(theme => ({
  root: {
    // padding: "16px 0px",
    backgroundColor: theme.palette.white,
    // boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.15)",
    boxShadow: 'none',
    zIndex: "2",
        ['@media (max-width: 992px)']: {
          padding: "12px 0px 8px",

    },
  },
  topBar: {
    position: "sticky",
    top: "0px",
    height: TopBarHeight,

  },
  content: {
    justifyContent: "space-between",
    width: "100%"
  },
  desktopContent: {
    display: "flex",
    ['@media (max-width: 992px)']: {
      display: "none",
    },
  },
  mobileContent: {
    display: "none",
    ['@media (max-width: 992px)']: {
      display: "flex",
      alignItems: "center",
      position: "relative",
    },
  },
  headerLinkContainer: {
    display: "flex",
    position: "absolute",
    top: "0px",
    left: "0px",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1
  },
  headerLink: {
    // marginTop: "- 6rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    textDecoration: "none",
    color: "black",
    width: "24rem",
    // marginTop: "0.5rem",
    marginRight: "1rem",
    ['@media (max-width: 992px)']: {
      width: "45px",
      height: "45px",
    },
  },
  image: {
    width: "252px",
    height: "20px",
  },
  navLinksContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-end"
  },
  navLinksRow: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  },
  navLinkMargin: {
    margin: "0px 14px",
    "&:first-child": {
      marginLeft: "0px"
    },
    "&:last-child": {
      marginRight: "0px"
    }
  },
  navLink: {
    display: "block",
    fontSize: "18px",
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: "29px",
    color: theme.palette.black,
    textDecoration: "none",
    // textTransform: "uppercase",
    '&:hover': {
      color: theme.palette.black,
      textDecoration: "underline",
    },
    ['@media (max-width: 992px)']: {
      fontSize: "12px"
    }
  },
  navLinkText: {
    display: "inline-block",
    fontSize: "0.875rem",
    fontWeight: theme.typography.fontWeightBold
  },
  serviceHotline: {
    fontSize: "16px",
    fontWeight: theme.typography.fontWeightLight,
    marginBottom: "16px",
    textTransform: "uppercase",
    "& a": {
      color: theme.palette.black,
      textDecoration: "none",
      letterSpacing: "0.7px"
    },
    "& a:hover": {
      color: theme.palette.black,
      textDecoration: "underline",
    }
  },
  serviceHotlineLink: {
    color: theme.palette.black,
    textDecoration: "none",
    '&:hover': {
      color: theme.palette.black,
      textDecoration: "underline",
    }
  },
  signInLinkContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: "28px",
    gap: "0.5rem",
    ['@media (max-width: 992px)']: {
      marginLeft: "0px",
      zIndex: 2
    },
  },
  badge: {
    flexBasis: "24px",
    height: "24px",
    flexShrink: 0,
    display: "block",
    marginRight: "8px"
  },
  tooltip: {
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: "16px",
    lineHeight: "20px",
    padding: "8px 16px"
  },
  signInLink: {
    color: theme.palette.black,
    display: "flex",
    fontWeight: theme.typography.fontWeightMedium,
    textDecoration: "underline",
    marginLeft: "0px"
  },
  signUpLink: {
    color: theme.palette.white,
    backgroundColor: theme.palette.lightGreen,
    padding: '10px 20px 10px 20px',
    display: "flex",
    fontWeight: theme.typography.fontWeightRegular,
    textDecoration: "none",
    borderRadius: ".5rem",
    marginLeft: "0px",
    ['@media (max-width: 992px)']: {
      padding: '5px 10px 5px 10px',
    }
  },
  signInLink: {
    color: theme.palette.lightGreen,
    borderColor: theme.palette.lightGreen,
    backgroundColor: theme.palette.white,
    borderStyle: "solid",
    borderWidth: "thin",

    padding: '10px 20px 10px 20px',
    display: "flex",
    fontWeight: theme.typography.fontWeightRegular,
    textDecoration: "none",
    borderRadius: ".5rem",
    marginLeft: "0px",
    ['@media (max-width: 992px)']: {
      padding: '5px 10px 5px 10px',
    }
  },
  signInLinkTag: {
    color: theme.palette.black,
    display: "inline-flex",
  },
  signInLinkText: {
    color: theme.palette.black
  },
  signInLogo: {
    marginRight: "12px",
    height: "24px",
    width: "24px",
    ['@media (max-width: 768px)']: {
      marginRight: "0px",
    }
  },
  signInPart: {
    lineHeight: "24px",
  },
  logOutIcon: {
    height: "25px",
    width: "25px",
    marginRight: "11px",
    padding: "0"
  },
  menuButton: {
    padding: "0px",
    zIndex: 2
  },
  subMenu: {
    fontSize: "16px",
    fontWeight: theme.typography.fontWeightLight,
    color: theme.palette.black,
    textDecoration: "none",
    textTransform: "uppercase",
    margin: "0px 14px",
    height: "30px",
    '&:hover': {
      color: theme.palette.black,
      textDecoration: "underline",
    },
    padding: "3px",
    zIndex: "3"
  },
  subMenuContainer: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    backgroundColor: "white",
    border: "1px solid #e9e9e9",
    minWidth: "200px",
    marginTop: "10px",
    marginLeft: "-10px",
    zIndex: "3"
  }
}));

let futureMenu = ""

const PageHeader = (props) => {
  const classes = blockStyles();

  const menuButton = useRef();

  const [menus, setMenus] = useState(props.menus);
  const [currentUser, setCurrentUser] = useState(props.currentUser);
  const [adminDashboardAbilityInfo, setAdminDashboardAbilityInfo] = useState(props.adminDashboardAbilityInfo);
  const [userOnceLoaded, setUserOnceLoaded] = useState(props.userOnceLoaded);
  const [menuOpen, setMenuOpen] = useState(false);
  const [subMenu, setSubMenu] = useState("")

  const badgesForStatuses = {
    identification_required: <IcRedBadge />,
    identification_pending: <IcGrayBadge />,
    identified: <IcGreenBadge />
  }

  useEffect(() => {
    setMenus(props.menus);
  }, [props.menus]);

  useEffect(() => {
    setUserOnceLoaded(props.userOnceLoaded);
  }, [props.userOnceLoaded]);

  useEffect(() => {
    setCurrentUser(props.currentUser);
  }, [props.currentUser]);

  useEffect(() => {
    setAdminDashboardAbilityInfo(props.adminDashboardAbilityInfo);
  }, [props.adminDashboardAbilityInfo]);

  const onMenuOpen = () => {
    setMenuOpen(true);
  }

  const onMenuClose = () => {
    setMenuOpen(false);
  }

  const fixSubMenu = () => {
    setSubMenu(futureMenu)
  }

  const onClickLogOut = () => {
    const { signOut, history } = props;
    if(signOut) {
      signOut(() => {
        history.push(Routes.xavin())
      })
    }
  }

  const subMenuToggle = (key) => {
    if(key != "")
      setSubMenu(key)
    futureMenu = key
    setTimeout(function() {
      fixSubMenu();
   }, 3000 );
  }

  const headerLink = () => {
    if(!userOnceLoaded) {
      return <React.Fragment />
    }
    if(currentUser) {
      return <div className = { classes.signInLinkContainer } >
        { badge() }
        <Link to = { Routes.profile() }
              className = { clsx(classes.navLink, classes.signInLink) } >
          <IcLightUser className = { classes.signInLogo }/>
          <span className = { classes.navLinkText } >
            { UserModel.displayValue(currentUser) }
          </span>
        </Link>
      </div>
    }
    return <div className = { classes.signInLinkContainer } >
      <div className = { clsx(classes.navLink) }>
        <Link to = { Routes.signIn() } className = { clsx(classes.signInPart, classes.signInLink) }>
          <span className = { classes.navLinkText } >
            {I18n.t("shared.sign_in")}
          </span>
        </Link>
      </div>
      <div className = { clsx(classes.navLink) }>
        <Link to = { Routes.signUp() }
              className = { clsx(classes.signInPart, classes.signUpLink) }>
          <span className = { classes.navLinkText } >
            {I18n.t("shared.sign_up")}
          </span>
        </Link>
      </div>
    </div>
  }

  const headerLinkMobile = () => {
    if(!userOnceLoaded) {
      return <React.Fragment />
    }
    if(!currentUser) {
      return <div className = { classes.signInLinkContainer } >
        <div className = { clsx(classes.navLink) }>
          <Link to = { Routes.signUp() }
                className = { clsx(classes.signInPart, classes.signUpLink) }>
            <span className = { classes.navLinkText } >
              {I18n.t("shared.sign_up_now")}
            </span>
          </Link>
        </div>
      </div>
    }
    return <div className = { classes.signInLinkContainer } >
      { badge() }
      <Link to = { Routes.profile() }
            className = { clsx(classes.navLink, classes.signInLink) } >
        <IcLightUser className = { classes.signInLogo }/>
      </Link>
    </div>
  }

  const badge = () => {
    if(adminDashboardAbilityInfo.use || UserModel.identificationStatus(currentUser) === "unidentified") {
      return <React.Fragment />
    }
    return <Link to = { currentUser.isIdentified ? Routes.profile() : Routes.profileIdentify() }
                 className = { classes.badge } >
      <Tooltip content = {
          <div className = { classes.tooltip } >
            { I18n.t(`web.identification.${UserModel.identificationStatus(currentUser)}.tooltip`) }
          </div>
        }>
        { badgesForStatuses[UserModel.identificationStatus(currentUser)] }
      </Tooltip>
    </Link>
  }

  const mainMenus = (key) => {
    const filteredMenus = menus.filter(({menu}) => { return menu == key })
    if(filteredMenus.length == 0)
      return <React.Fragment />
    return filteredMenus.map(({ name, slug }) =>
            <div key={slug}
            className = { classes.navLinkMargin }
            onMouseLeave = { () => subMenuToggle("") }
            onMouseEnter = { () => subMenuToggle(slug) }>
              <HashLink key={slug} to = {Routes.page(slug)} className = { classes.navLink } >
                {name}
              </HashLink>
              { subMenus(slug) }
            </div>
          )

  }

  const subMenus = (key) => {
    if(subMenu != key)
      return <React.Fragment />
    const filteredMenus = menus.filter(({menu}) => { return menu == key })
    if(filteredMenus.length == 0)
      return <React.Fragment />
    return <div className = { classes.subMenuContainer }
      onMouseMove = { () => subMenuToggle(key) }
      onMouseLeave = { () => subMenuToggle("1") }
      >
        {
          filteredMenus.map(({ name, slug }) =>
            <HashLink key={slug} to = {Routes.page(slug)} className = { classes.subMenu } >
              {name}
            </HashLink>
          )
        }
      </div>
  }

  const src = "/icons/moto/gut_fuer_ihr_geld.png";
  const srcSet = {
    "2x": "/icons/moto/gut_fuer_ihr_geld@2x.png",
    "3x": "/icons/moto/gut_fuer_ihr_geld@3x.png"
  }
  const desktopContent = () => {
    return <div className = { clsx(classes.content, classes.desktopContent) } >
      <Link to = { Routes.xavin() }
            className = { classes.headerLink } >
        <MybilioTextLogoBronze className = { classes.headerLogo } />
        <Image className = { classes.image }
                scaleMode = "contain"
                alt = { I18n.t("shared.gut_fuer_ihr_geld") }
                src = { src }
                srcSet = { srcSet } />
      </Link>
      <div className = { classes.spacing } />
      <div className = { classes.navLinksContainer } >
        <div className = { classes.navLinksRow } >
          {/* <div className = { classes.navLinkMargin } >
            <HashLink to = { Routes.index({anchor: ProjectsAnchor}) }
                  className = { classes.navLink } >
              { I18n.t("shared.projects")}
            </HashLink>
          </div> */}

          <div key={"logout"}
            className = { classes.navLinkMargin }
            onMouseLeave = { () => subMenuToggle("") }
            onMouseEnter = { () => subMenuToggle("logout") }>
            {/* <IconButton className = { classes.signInLink } onClick = { onClickLogOut } >
              <IcLogOut className = { classes.logOutIcon } />
            </IconButton> */}

            { currentUser && <HashLink
                onClick = { onClickLogOut }
                className = { classes.navLink }
                to = { "#" }
                >
                { I18n.t("shared.log_out") }
              </HashLink>
            }
          </div>
          { mainMenus('main') }
          { headerLink() }
        </div>
      </div>
    </div>
  }

  const mobileContent = () => {
    return <div className = { clsx(classes.content, classes.mobileContent) } >
      <IconButton className = { classes.menuButton }
                  onClick = { onMenuOpen }
                  ref = { menuButton } >
        <IcMenu />
      </IconButton>
      <Link to = { Routes.xavin() }
            className = { classes.headerLink } >
        <MybilioTextBronze className = { classes.headerLogo } />
      </Link>
      { headerLinkMobile() }
    </div>
  }

  return (
    <AppBar className = { classes.root } >
      <Toolbar className = { classes.topBar } >
        <Container>
          <LeftMenu open = { menuOpen }
                    menus = { menus }
                    onClose = { onMenuClose } />
          { desktopContent() }
          { mobileContent() }
        </Container>
      </Toolbar>
    </AppBar>
  );
}

export default compose(withRouter, withCurrentUser)(PageHeader)
